module.exports = __webpack_public_path__ + "img/rlogo-loader_250.4f2e4755.gif";